import {
    takeEvery,
    call,
    put,
    select,
    takeLatest,
    race
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { getConsumerFees } from 'capi';

import { consumerFeesFetchFailed, REQUEST_CONSUMER_FEES, setConsumerFees } from './consumerFeeModule';
import { getCapiClient } from '../session/sessionSelectors';
import { INTL_CURRENCY_UPDATED } from '../intl/intlModule';
import { getIntlCurrencyCode } from '../intl/intlSelectors';
import { logError, reportPageLoadError } from '../utils/errorUtils';

export function* requestConsumerFees({ currencyCode = '' }) {
    const capi = yield select(getCapiClient);

    const CONSUMER_FEES_FETCH_TIMEOUT = 10; // 10 seconds

    try {
        const { response, timeout } = yield race({
            response: call(getConsumerFees, capi, currencyCode),
            timeout: delay(CONSUMER_FEES_FETCH_TIMEOUT * 1000)
        });

        if (timeout) {
            logError('Timeout while fetching consumer fees', { currencyCode });
            reportPageLoadError('Error in getShareableLinkDetails', 'Timeout while fetching consumer fees', { currencyCode });
            yield put(consumerFeesFetchFailed()); 
            return;
        }

        yield put(setConsumerFees(response, currencyCode));
    } catch (error) {
        logError('Error while fetching consumer fees', { error, currencyCode });
        reportPageLoadError('Error while fetching consumer fees', 'Error while fetching consumer fees', { error, currencyCode });
        yield put(consumerFeesFetchFailed());
    }
}

export function* requestConsumerFeesOnCurrencyChange() {
    const currencyCode = yield select(getIntlCurrencyCode);
    yield call(requestConsumerFees, { currencyCode });
}

export function* consumerFeeSagaWatcher() {
    yield takeEvery(REQUEST_CONSUMER_FEES, requestConsumerFees);
    yield takeLatest(INTL_CURRENCY_UPDATED, requestConsumerFeesOnCurrencyChange);
}
